import React from 'react';
import { Link } from 'react-router-dom';

interface EmptyStateProps {
  icon?: string;
  title: string;
  message: string;
  actionLabel?: string;
  actionPath?: string;
  onAction?: () => void;
}

export default function EmptyState({
  icon = '📭',
  title,
  message,
  actionLabel,
  actionPath,
  onAction
}: EmptyStateProps) {
  return (
    <div className="bg-white rounded-lg shadow-md p-12 text-center dark:bg-gray-800 dark:text-gray-100">
      <div className="text-6xl mb-4">{icon}</div>
      <h3 className="text-2xl font-bold text-gray-800 mb-2 dark:text-gray-200">{title}</h3>
      <p className="text-gray-600 mb-6 dark:text-gray-400">{message}</p>
      {(actionLabel && actionPath) && (
        <Link
          to={actionPath}
          className="inline-block bg-amber-700 text-white px-6 py-3 rounded-lg hover:bg-amber-800 transition font-medium"
        >
          {actionLabel}
        </Link>
      )}
      {actionLabel && onAction && (
        <button
          onClick={onAction}
          className="bg-amber-700 text-white px-6 py-3 rounded-lg hover:bg-amber-800 transition font-medium"
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
}
